import { useEffect, useRef, useState } from 'react';
import requestDeduplicator from '../utils/requestDeduplicator';

const HTTP_FORBIDDEN = 403;

const initialState = {
  data: null,
  loading: true,
  error: null,
  forbidden: false,
};

const useDashboardMetric = ({ cacheKey, fetcher, enabled = true, revision = 0 }) => {
  const [state, setState] = useState(initialState);
  const fetcherRef = useRef(fetcher);

  useEffect(() => {
    fetcherRef.current = fetcher;
  }, [fetcher]);

  useEffect(() => {
    if (!enabled) {
      setState({ ...initialState, loading: false });
      return undefined;
    }

    let cancelled = false;
    setState((previous) => ({ ...previous, loading: true, error: null, forbidden: false }));

    requestDeduplicator.deduplicate(cacheKey, () => fetcherRef.current())
      .then((data) => {
        if (!cancelled) setState({ data, loading: false, error: null, forbidden: false });
      })
      .catch((error) => {
        if (cancelled) return;

        const forbidden = error?.response?.status === HTTP_FORBIDDEN;
        setState({ data: null, loading: false, error: forbidden ? null : error, forbidden });
      });

    return () => {
      cancelled = true;
    };
  }, [cacheKey, enabled, revision]);

  return state;
};

export default useDashboardMetric;
